<mat-card class="example-card">
  
    <mat-card-content >
      <img mat-card-image class="example-header-image" src="https://assets.itrustpro.com/kennel/assets/logos/runloyal1.png" alt="Runloyal">
      <mat-divider ></mat-divider>
      <h1 style="padding-top: 50px;padding-bottom: 10px;" id="mainText">{{ message }}</h1>
      <!-- <section class="example-section" style="padding-bottom: 10px;">
          <mat-checkbox class="example-margin">Save this card securely for future transaction.</mat-checkbox>           
        </section> -->
        <!-- <mat-card-actions style="padding-bottom: 20px;">
          <button mat-button style="background-color: #41A049 !important;color:white" (click)="closePopUp()">OK</button>
            </mat-card-actions> -->
  </mat-card-content>
  
  <mat-divider ></mat-divider>
      <mat-card-footer>
          <a href="https://www.runloyal.com/" target="_blank" class="text-dark"><img mat-card-image class="footer-image" src="https://assets.itrustpro.com/kennel/assets/portal/madewithlove1.png" alt="Runloyal">
          </a>
      </mat-card-footer>
       
</mat-card>
